import { render } from "./QuestionsReview.vue?vue&type=template&id=2d9f2758&scoped=true"
import script from "./QuestionsReview.vue?vue&type=script&lang=js"
export * from "./QuestionsReview.vue?vue&type=script&lang=js"

import "./QuestionsReview.vue?vue&type=style&index=0&id=2d9f2758&scoped=true&lang=css"

import exportComponent from "/home/isga_open/deploy/releases/767/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9f2758"]])

export default __exports__